export default "__VITE_ASSET__lTa$SPpQ__"